const metaMot = { rules: ['TEMPORARIO-00'] };

const motRoutes = [
    {
        path: 'mao-de-obra-temporaria',
        name: 'SolicitacoesServicos_MOT_Listagem',
        component: () => import('./Listagem.vue'),
        meta: metaMot,
    },
    {
        path: 'mao-de-obra-temporaria/nova',
        name: 'SolicitacoesServicos_MOT_Nova',
        component: () => import('./Formulario.vue'),
        meta: metaMot,
    },
    {
        path: 'mao-de-obra-temporaria/:id/editar',
        name: 'SolicitacoesServicos_MOT_Editar',
        component: () => import('./Formulario.vue'),
        meta: metaMot,
    },
    {
        path: 'mao-de-obra-temporaria/:id',
        name: 'SolicitacoesServicos_MOT_Detalhar',
        component: () => import('./Detalhar.vue'),
        meta: metaMot,
    },
];

export default motRoutes;

